import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url

export const state = {
  currentSession: getSavedState('auth.currentSession')
}

export const mutations = {
  SET_CURRENT_SESSION(state, newValue) {
    state.currentSession = newValue
    saveState('auth.currentSession', newValue)
  },
  SET_ACTIVE_SECTION(state, newValue) {
    state.currentSession.user.app_sections_tree = newValue
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentSession
  },
  currentSession: state => state.currentSession
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(`${serverUrl}/api-auth/`, { username, password })
      .then(({ data }) => {
        if (Object.keys(data).includes("error")) {
          return { error: data.error, data: null }
        }
        commit('SET_CURRENT_SESSION', data)
        return { error: null, data }
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_SESSION', null)
    saveState('appAuth.appSession', null)
    saveState('appAuth.companyInfo', null)
  },

  // register the user
  register({ commit, dispatch, getters }, { fullname, email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/register', { fullname, email, password })
      .then((response) => {
        const user = response.data
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post('/api/reset', { email })
      .then((response) => {
        const message = response.data
        return message
      })
  },

  setUserActiveSection(context, currentPath) {
    context.state.currentSession.user
      .app_sections_tree.forEach(section => {
        if ('children' in section) {
          section.children.forEach(secondLevelSection => {
            if ('children' in secondLevelSection && secondLevelSection.path !== currentPath) {
              secondLevelSection.children.forEach(thirdLevelSection => {
                section['active'] = thirdLevelSection.path === currentPath
                secondLevelSection['active'] = thirdLevelSection.path === currentPath
                thirdLevelSection['active'] = thirdLevelSection.path === currentPath
              });
            } else {
              section['active'] = secondLevelSection.path === currentPath
              secondLevelSection['active'] = secondLevelSection.path === currentPath
            }
          });
        } else {
          section['active'] = section.path === currentPath
        }
      });
    context.commit('SET_ACTIVE_SECTION', context.state.currentSession.user
      .app_sections_tree)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }, force) {
    if (!state.currentSession) return Promise.resolve(null)
    let parsedDatetime = new Date(Date.parse(state.currentSession.expires))
    let actualDatetime = new Date()
    let datetimesDiff = parsedDatetime - actualDatetime
    if (((datetimesDiff / (1000 * 60)) < 5 && (datetimesDiff / (1000 * 60)) > 0) || force) {
      return axios
        .post(`${serverUrl}/api-auth/token-refresh/`, { 'token': state.currentSession.key })
        .then((response) => {
          const user = response.data
          commit('SET_CURRENT_SESSION', user)
          return user
        })
        .catch(() => {
          // if (error.response && (error.response.status === 401 || error.response.status === 400)) {
          //   commit('SET_CURRENT_SESSION', null)
          // }
          commit('SET_CURRENT_SESSION', null)
          return null
        })
    } else if ((datetimesDiff / (1000 * 60)) <= 0) {
      commit('SET_CURRENT_SESSION', null)
      return null
    } else {
      return state.currentSession.user
    }
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}